<template lang="pug">
pr-wrapper.message-detail-container.animated(
  fs,
  bg,
  zi="2",
  v-nv:scope="'message-detail'",
  nv-exit-protect,
  @nv-exit.native="close",
  @nv-back.native="close",
  @nv-right.native="close",
  :class="{ visible: isVisible }"
)
  .messages-header.border-bottom.px-5.pt-4.pb-4.shadow
    .title.d-flex.align-items-center
      pr-subtitle.flex-grow-1 {{ data.title }}
      pr-button.bordered(ref="back")
        span {{ $t('Close') }}
        icon.animated.ml-2(:icon="'arrow-right'")
    .sub-info.d-flex.mt-2
      pr-text.text-muted.flex-grow-1.font-weight-bold {{ `${$t('From')}: ${data.from}` }}
      moment.small.text-muted.pl-2.font-weight-bold(humanize, format="date", :value="data.date")
  .messages-body.position-relative.flex-grow-1
    pr-wrapper.px-5.pt-4.pb-5.content-wrapper(fs, v-nv, ref="scrollArea", @nv-up.native="scroll", @nv-down.native="scroll", @nv-enter.native="close")
      .content(v-html="data.text")
</template>

<script>
export default {
  name: "message-detail",
  props: ["message"],
  computed: {
    data() {
      return this.message || {}
    },
    isVisible() {
      return this.message ? true : false
    }
  },
  watch: {
    message() {
      this.$refs.back.$el.classList.add("nv-el-current")
    }
  },
  mounted() {
    _$.nav.sync("message-detail")
  },
  methods: {
    scroll($event, toTop = false) {
      let scrollTop = this.$refs.scrollArea.$el.scrollTop
      switch ($event.type) {
        case "nv-down":
          scrollTop += 200
          break
        case "nv-up":
          scrollTop -= 200
          break
      }
      if (toTop) scrollTop = 0
      $(this.$refs.scrollArea.$el).animate({ scrollTop: scrollTop }, 200, () => this.triggerBackButton())
    },
    triggerBackButton() {
      let scrollTop = this.$refs.scrollArea.$el.scrollTop
      if (scrollTop <= 0) {
        this.$refs.back.$el.classList.add("nv-el-current")
      } else {
        this.$refs.back.$el.classList.remove("nv-el-current")
      }
    },
    close($event) {
      let scrollTop = $event.target.scrollTop
      if ($event.type === "nv-back" || $event.type === "nv-right") this.$emit("close-detail")
      else if (scrollTop <= 0) this.$emit("close-detail")

      this.scroll($event, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.message-detail-container {
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  &.visible {
    transform: translateX(0);
  }
}
.content-wrapper {
  overflow: auto;
}
.content {
  line-height: 1.5em;
  font-size: 1.2em;
}
</style>
